import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVivaldiComponent } from './simple-icons-vivaldi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVivaldiComponent ],
    exports:      [ SimpleIconsVivaldiComponent ],
    bootstrap:    []
})
export class SimpleIconsVivaldiModule {}
